import { render, staticRenderFns } from "./MySubmissions.vue?vue&type=template&id=585f9e74&"
import script from "./MySubmissions.vue?vue&type=script&lang=js&"
export * from "./MySubmissions.vue?vue&type=script&lang=js&"
import style0 from "./MySubmissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports